/* eslint-disable import/no-anonymous-default-export */

import { PiCheckCircle } from "react-icons/pi";
export default ({
    title, text, cl, ic
}
) => {

    return (
        <div className="p-2  flex flex-col justify-start h-full  transition ease-in-out hover:-translate-y-1 hover:scale-110 focus:scale-110  duration-300 focus:-translate-y-1  ">
            {ic ? <PiCheckCircle className="text-8xl text-[#7BABFF] " /> : null}
            <p className={cl + ` font-semibold  text-start  my-8 `}>
                {title}
            </p>
            <div className="text-start   text-lg font-normal " >{text}</div>
        </div>
    );
};
